import React from 'react';
import {ContactDaysAgo} from '../Decorators/Checkmarks'
import {inRange} from '../maps/siteNames'

import './SiteHealth.css'
import '../navbar/footer.css'

export default function SiteHealth (props) {
  const h = siteHealth(props)
  const cache = props.siteMap()
  return (
    <>
    <span className="site-score footer-content">{h}/{cache?.size}</span>
    <span className="badge bg-warning bg-touchup footer-badge">{props?.filterLabel??' '}</span>
    </>
  )  
}
function siteHealth (props) {
  let score = 0;
  const cache = props.siteMap()
  if (cache.size > 0) {
    for (const site of cache) {
      score += inRange(ContactDaysAgo({"site": site[1]}), props.healthFilter);
    }
  }
  return score;
}
